// extracted by mini-css-extract-plugin
export default {"wrapper":"RemoveModal_wrapper__4h1ox","confirm-button":"RemoveModal_confirm-button__wM01O"};